import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AxiosError } from "axios";
import { Api } from "services/api/api.service";

type SaveParams = {
  salaryNoticeId: number;
  value: number;
  workerId: number;
};

export type AdjustSalaryStatus =
  | { type: "idle" }
  | { type: "submitting" }
  | { type: "success" }
  | { type: "error"; message: string };

type UseAdjustSalaryReturn = {
  reset: () => void;
  save: (params: SaveParams) => void;
  status: AdjustSalaryStatus;
};

export const useAdjustSalary = (companyId: number): UseAdjustSalaryReturn => {
  const { t } = useTranslation();
  const [status, setStatus] = useState<AdjustSalaryStatus>({ type: "idle" });

  const save = ({ workerId, salaryNoticeId, value }: SaveParams): void => {
    setStatus({ type: "submitting" });
    Api()
      .company.salary.putAdditionalRow(companyId, workerId, {
        key: 3000,
        value,
        salaryNoticeId,
        count: 1,
      })
      .then(() =>
        Api().company.salary.regenerateSalaryNotice(
          companyId,
          workerId,
          salaryNoticeId,
        ),
      )
      .then(() => {
        setStatus({ type: "success" });
      })
      .catch((err: AxiosError<{ message?: string }>) => {
        const message =
          err.response?.data?.message ?? String(t("Alerts.SomethingWentWrong"));
        setStatus({ type: "error", message });
      });
  };

  const reset = (): void => setStatus({ type: "idle" });

  return { reset, save, status };
};
